export const useAuth = () => !!localStorage.getItem('ton-connect-storage_bridge-connection');
